import { render, staticRenderFns } from "./flowConfirm.vue?vue&type=template&id=24f12cea&scoped=true&lang=pug&"
import script from "./flowConfirm.vue?vue&type=script&lang=js&"
export * from "./flowConfirm.vue?vue&type=script&lang=js&"
import style0 from "./flowConfirm.vue?vue&type=style&index=0&id=24f12cea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f12cea",
  null
  
)

export default component.exports